import styled, { keyframes } from "styled-components";
import Animate from "./Animate";

const fadeInLeft = keyframes`
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
`;

const FadeLeftWrap = styled(Animate)`
    & {
      opacity: 0;
    }

    &.fadeLeft{
        animation:${fadeInLeft} 0.5s forwards;
    }
`;

FadeLeftWrap.defaultProps = {
    effectClassName: "fadeLeft"
};

export default FadeLeftWrap;